import React from "react";
import EmployeeForm from "./EmployeeForm";

function CreateNewEmployee() {
  return <EmployeeForm mode="create" />;
}

export default CreateNewEmployee;
